import { render, staticRenderFns } from "./diversity.html?vue&type=template&id=e35deb48&scoped=true&"
import script from "./diversity.vue?vue&type=script&lang=js&"
export * from "./diversity.vue?vue&type=script&lang=js&"
import style0 from "./diversity.scss?vue&type=style&index=0&id=e35deb48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35deb48",
  null
  
)

export default component.exports